import styled from "styled-components";

const FormInput = styled.input`
    display: block;
    height: 40px;
    width: 100%;
    padding: 7px 16px;

    font-size: 14px;

    background-color: var(--light-gray2);
    background-clip: padding-box;
    border: 1px solid var(--light-gray2);
    border-radius: 8px;
    color: var(--dark-gray2);

    outline: 0;
    &::-webkit-input-placeholder {
        color: var(--midle-gray1);
    }
    &:-ms-input-placeholder {
        color: var(--midle-gray1);
    }
    &::placeholder {
        color: var(--midle-gray1);
    }
    &:focus {
        border-color: var(--light-gray4);
    }
`;

export default FormInput